(() => {
  const SELECTOR = '.smpl_product_faq_section .wp-block-uagb-faq .wp-block-uagb-faq-child details';
  const ANIMATION_DURATION = 360;

  const setExpandedState = (details, expanded) => {
    const contentWrap = details.querySelector('.uagb-faq-content-wrap');
    const content = details.querySelector('.uagb-faq-content');

    if (!contentWrap || !content) return;

    if (expanded) {
      details.open = true;
      contentWrap.style.height = '0px';

      requestAnimationFrame(() => {
        contentWrap.style.height = `${content.offsetHeight}px`;
      });

      const onOpened = (event) => {
        if (event.propertyName !== 'height') return;
        contentWrap.style.height = 'auto';
        contentWrap.removeEventListener('transitionend', onOpened);
      };

      contentWrap.addEventListener('transitionend', onOpened);
      return;
    }

    contentWrap.style.height = `${content.offsetHeight}px`;

    requestAnimationFrame(() => {
      contentWrap.style.height = '0px';
    });

    const onClosed = (event) => {
      if (event.propertyName !== 'height') return;
      details.open = false;
      contentWrap.removeEventListener('transitionend', onClosed);
    };

    contentWrap.addEventListener('transitionend', onClosed);
  };

  const animateDetails = (details, expanded) => {
    if (details.hasAttribute('data-animating')) return;

    details.setAttribute('data-animating', 'true');
    setExpandedState(details, expanded);

    window.setTimeout(() => {
      details.removeAttribute('data-animating');
    }, ANIMATION_DURATION);
  };

  const closeSiblingDetails = (details) => {
    const group = details.closest('.wp-block-uagb-faq');

    if (!group) return;

    group.querySelectorAll('details[open]').forEach((item) => {
      if (item === details) return;
      animateDetails(item, false);
    });
  };

  const bindAccordion = (details) => {
    const summary = details.querySelector('.uagb-faq-questions-button');
    const contentWrap = details.querySelector('.uagb-faq-content-wrap');
    const content = details.querySelector('.uagb-faq-content');

    if (!summary || !contentWrap || !content) return;

    if (details.open) {
      contentWrap.style.height = 'auto';
    } else {
      contentWrap.style.height = '0px';
    }

    summary.addEventListener('click', (event) => {
      event.preventDefault();

      if (details.hasAttribute('data-animating')) return;

      const expanded = !details.open;

      if (expanded) {
        closeSiblingDetails(details);
      }

      animateDetails(details, expanded);
    });
  };

  const init = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((details) => {
      if (details.hasAttribute('data-faq-bound')) return;
      details.setAttribute('data-faq-bound', 'true');
      bindAccordion(details);
    });

    root.querySelectorAll('.smpl_product_faq_section .wp-block-uagb-faq').forEach((group) => {
      let foundOpen = false;

      group.querySelectorAll('details').forEach((details) => {
        const contentWrap = details.querySelector('.uagb-faq-content-wrap');

        if (!contentWrap) return;

        if (details.open && !foundOpen) {
          foundOpen = true;
          contentWrap.style.height = 'auto';
          return;
        }

        details.open = false;
        contentWrap.style.height = '0px';
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
